<template>
  <div>
    <v-form ref="form">
      <v-dialog
        fullscreen
        value="true"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar flat class="card-toolbar-title">
            <v-toolbar-title>
              {{ editedItem.documentId ? 'Edit' : 'Add' }} Client Document
            </v-toolbar-title>
            <v-spacer />
            <v-btn icon @click.native="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-app-bar>

          <v-card-text>
            <v-text-field
              id="description"
              v-model="editedItem.description"
              :rules="required"
              class="required"
              label="Display Name"
              name="description"
            />
            <label class="required" for="documentData">
              File Name
            </label><br />
            <input
              id="documentData"
              name="documentData"
              type="file"
              @change="onFileChange"
            />
            <v-radio-group v-model="editedItem.documentType" class="required" :rules="required" label="Document Type">
              <v-radio label="Member" value="M" />
              <v-radio label="Client" value="C" />
            </v-radio-group>
          </v-card-text>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn text color="primary" @click.native="close">Cancel</v-btn>
              <v-btn color="primary" @click.native="save">Save</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'client-documents-table-modal',
  props: {
    editedItem: Object
  },
  data() {
    return {
      required: [
        v => !!v || 'Required'
      ]
    }
  },
  methods: {
    ...mapActions('manageClientDocuments', ['changeClientDocument']),
    onFileChange(e) {
      this.editedItem.documentData = e.target.files[0]
    },
    save() {
      if (this.$refs.form.validate() && (this.editedItem.documentId || this.editedItem.documentData)) {
        this.changeClientDocument(this.editedItem).then(e => this.$emit('saved', e.data), () => {})
      }
    },
    close() {
      this.$emit('close')
    }

  }
}
</script>

<style lang="scss" scoped>
  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }

  .card-toolbar-title {
    background-color: $color-secondary;
  }
</style>
